import { Heading } from '@chakra-ui/react';
import { FC } from 'react';
import MainContent from '../../../components/Generic/MainContent';
import CreatePageButton from '../components/CreatePage';
import PageList from '../components/PageList';

const DynamicPages: FC = () => {
  return (
    <>
      <MainContent maxH="100svh" overflowY="auto">
        <Heading mb="48px" color="#469BFF" fontFamily="Poppins">
          Páginas Dinâmicas
        </Heading>

        <CreatePageButton maxW="196px" py={2} />

        <PageList />
      </MainContent>
    </>
  );
};

export default DynamicPages;
